"use client";

import { ArrowRight, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function TheMetalLinePortfolio() {
  const tickerItems = ["PRECISION ENGINEERING", "ARCHITECTURAL GRADE", "CALGARY BUILT", "DURABLE EXTERIORS", "MODERN AESTHETIC", "PREMIUM MATERIALS"];
  const collageImages = [{
    src: "https://7oo.ca/wp-content/uploads/2026/07/Standing-seam-feature-wide.png?v=r8p28onqfjd",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/Standing-seam-feature-wide.png?v=7eebdgc2upk-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/Standing-seam-feature-wide.png?v=fzxuo11kn4c-wvc-sizes",
    alt: "Premium standing seam metal roof installation in Calgary",
    caption: "STANDING SEAM",
    index: "01"
  }, {
    src: "https://7oo.ca/wp-content/uploads/2026/07/Acm-panels-feature-wide.png?v=azdptqmb3n",
    srcset: "https://7oo.ca/wp-content/uploads/2026/07/Acm-panels-feature-wide.png?v=lxudn27dv2g-wvc-srcset",
    sizes: "https://7oo.ca/wp-content/uploads/2026/07/Acm-panels-feature-wide.png?v=ew9jugkjsmf-wvc-sizes",
    alt: "Modern architectural ACM panel cladding detail",
    caption: "ACM PANELS",
    index: "02"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/luxury_stone_veneer_exterior.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/luxury_stone_veneer_exterior.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713190/img/luxury_stone_veneer_exterior.png-wvc-sizes",
    alt: "High-end stone veneer and metal accent exterior",
    caption: "STONE VENEER",
    index: "03"
  }];
  return <section data-section-id="1273" id="the-metalline-portfolio" className="relative bg-background text-foreground overflow-hidden border-t border-border ![padding:50px_0px_50px_0px]">
      <div className="absolute top-8 right-6 md:right-12 hidden md:block">
        <div className="flex items-center gap-2 font-mono text-[0.7rem] text-muted-foreground tracking-widest uppercase">
        </div>
      </div>

      <div className="container mx-auto max-w-[1440px] px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="flex items-center gap-4 mb-6">
            </div>

            <h2 className="font-sans font-bold uppercase text-foreground mb-8 tracking-tighter" style={{
            fontSize: "clamp(2.5rem, 5vw, 4rem)",
            lineHeight: "1.05"
          }}>
              BUILT FOR THE <br />
              <span className="text-primary italic inline-block transform -skew-x-6">CALGARY</span> <br />
              CLIMATE.
            </h2>

            <div className="relative pl-8 mb-10">
              <div className="absolute left-0 top-0 bottom-0 w-px bg-primary/30" />
              <p className="font-sans text-muted-foreground max-w-[45ch]" style={{
              fontSize: "clamp(1.125rem, 1.2vw, 1.25rem)",
              lineHeight: "1.6"
            }}>
                Engineered for extreme durability and architectural elegance. We transform residential exteriors into high-performance, modern masterpieces using premium metal and composite materials.
              </p>
            </div>
          </div>

          <div className="lg:col-span-7 space-y-12">
            {collageImages.map((image, i) => <div key={i} data-index={i} className="group relative overflow-hidden rounded-md border border-border bg-card transition-all duration-500 hover:border-primary/50 shadow-md">
                <div className="grid grid-cols-1 md:grid-cols-12 items-stretch">
                  <div className="md:col-span-8 overflow-hidden">
                    <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" decoding="async" className="w-full aspect-[4/3] md:aspect-video object-cover transition-transform duration-700 ease-out group-hover:scale-105 grayscale-[0.2] group-hover:grayscale-0" />
                  </div>
                  <div className="md:col-span-4 p-8 flex flex-col justify-between bg-card">
                    <div>
                      <span className="font-mono text-[0.75rem] text-primary block mb-2">
                        {image.index}
                      </span>
                      <h3 className="font-sans font-bold text-xl uppercase tracking-tight mb-4">
                        {image.caption}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>

        {}
        <div className="mt-20 lg:mt-28 pt-12 border-t border-border flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="max-w-2xl">
            <h3 className="font-sans font-bold uppercase tracking-tighter text-3xl md:text-4xl">
              Like What You See?
            </h3>
            <p className="font-sans text-muted-foreground mt-2">
              Want a similar result for your home? Tell us about your project and get a free estimate from our Calgary team.
            </p>
          </div>
          <Button asChild className="bg-primary text-white hover:bg-primary/90 rounded-lg h-14 px-10 font-sans font-bold uppercase tracking-widest text-xs mt-8 shrink-0">
            <Link to="#start-your-transformation">
              Get a Free Estimate →
            </Link>
          </Button>
        </div>
      </div>

      <div className="mt-12 md:mt-24 lg:mt-40 border-t border-b border-border py-8 overflow-hidden bg-secondary/5 w-full">
        <div className="flex whitespace-nowrap md:animate-[ticker-scroll_30s_linear_infinite]">
          {[...tickerItems, ...tickerItems].map((item, i) => <div key={i} data-index={i} className="flex items-center shrink-0">
              <span className="font-mono uppercase text-foreground/40 px-12 text-lg md:text-2xl lg:text-4xl tracking-tighter font-bold">
                {item}
              </span>
              <div className="size-2 bg-primary rotate-45 shrink-0" />
            </div>)}
        </div>
        <style>{`
          @keyframes ticker-scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}</style>
      </div>
    </section>;
}